import { ChangeDetectionStrategy, Component, OnDestroy, Optional, ViewEncapsulation, computed, forwardRef, input } from "@angular/core";
import { InputFormWrapper } from "../wrapper.interface";
import { InputNumberConfig, NumberInputAffix } from "./input-number.config";
import { ControlContainer, NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";
import { InputNumberModule } from "primeng/inputnumber";
import { CommonModule } from "@angular/common";
import { AppService } from "src/services/app.service";
import { Subscription } from "rxjs";
import { V_FORM_CONTROL_TOKEN, WRAPPER_TOKEN } from "../wrapper.tokens";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector:      'v-input-number',
    templateUrl:   './input-number.component.haml',
    styleUrls:     ['./input-number.component.sass', '../input.style.sass'],
    encapsulation: ViewEncapsulation.None,
    providers:     [
        { provide: V_FORM_CONTROL_TOKEN, useExisting: forwardRef(() => VInputNumberComponent) },
        { provide: WRAPPER_TOKEN, useExisting: forwardRef(() => VInputNumberComponent) },
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => VInputNumberComponent), multi: true }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports:         [CommonModule, InputNumberModule, ReactiveFormsModule, TranslateModule]
})
export class VInputNumberComponent extends InputFormWrapper<InputNumberConfig, number> implements OnDestroy {
    protected _baseConfig: InputNumberConfig = InputNumberConfig.baseTheme.Default;
    private localeSubscription: Subscription;
    public locale: string;

    public readonly min = input<number>();
    public readonly max = input<number>();

    public prefix = computed(() => {
        const value = this.input_prefix() as NumberInputAffix !== undefined ? this.input_prefix() : this.config().prefix;
        if (value === "currency") return this.currency;
        return value;
    });
    public suffix = computed(() => {
        const value = this.input_suffix() as NumberInputAffix !== undefined ? this.input_suffix() : this.config().suffix;
        if (value === "currency") return this.currency;
        return value;
    });
    public get currency() {
        return "€";
    }
    constructor(
        protected service: AppService,
        @Optional() protected controlContainer: ControlContainer,
    ) {
        super(controlContainer);
        this.localeSubscription = service.$Locale.subscribe(x => this.locale = x);
    }

     writeValue(value: number): void {
        if (isNaN(value)) return;
        super.writeValue(value);
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this.localeSubscription?.unsubscribe();
    }
}